export function registerMeUser(meUser) {
  return {
    type: '@meUser/REGISTER',
    meUser,
  };
}

export function unregisterMeUser() {
  return {
    type: '@meUser/UNREGISTER',
  };
}

export function updateMeUser() {
  return {
    type: '@meUser/UPDATE',
  };
}
